import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import './home.css'
import { useGlobal } from '../../utils/GlobalContext';
import { session } from '../../data/session';
import { Box, Container } from '@mui/material';
import { UserProfile, newUserProfile } from '../../data/userProfile';
import SpeakerInfoModal from '../common/SpeakerInfoModal';

export default function EventKeynoteComponent() {
    const { state } = useGlobal();

    //Filter for keynote sessions
    const [keynoteSessions, setKeynotes] = useState<session[]>();
    useEffect(()=>{
        if(state.SelectedEvent?.Sessions.length!==0 && keynoteSessions?.length===undefined){
            const filteredKeynotes: session[] = state.SelectedEvent?.Sessions.filter(function (el) {
                return el.IsKeynote===true;
            });
            setKeynotes(filteredKeynotes);
        }
    });

    // Speaker Modal Hookup
    const [speakerInfoOpen, setSpeakerInfoOpen] = useState(false);
    const [selectedSpeaker, setSelectedSpeaker] = useState<UserProfile>(newUserProfile());
    const handleSpeakerModalOpen = (speaker: UserProfile) => {
        setSelectedSpeaker(speaker);
        setSpeakerInfoOpen(true);
    };
    const handleSpeakerModalClose = () => {
        setSpeakerInfoOpen(false);
    };
    
    return ( 
        <>
        <center>
            { keynoteSessions!==undefined &&
                    <h1 className='uppercase topSpacer80px'><span className='textAccentColor2'>{state.SelectedEvent?.Name}</span> <span className='textAccentColor1'>Keynote{keynoteSessions!==undefined && keynoteSessions?.length>1?`s`:``}</span></h1>
            }
        </center>
        {
            keynoteSessions?.map((keynote) => (
            <>  
                <div className='Keynote'>
                    <Container maxWidth="xl">
                        <center>
                            <h1 className='thin textAccentColor3'>
                                {keynote.Title}
                            </h1>
                        </center>                    
                        {
                            state.Profiles.map((profile) => (
                                profile.PresentationSessions.find((element) => element.EventId === keynote.EventId && element.SessionId === keynote.Id)!==undefined &&
                                <>
                                    <center>
                                        <h4 className='uppercase textAccentColor3'>{profile.FirstName} {profile.LastName}</h4>   
                                    </center>
                                    <Box sx={{ flexGrow: 1 }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={3}>
                                                <center>
                                                    <img className='KeynoteSpeakerImage' src={profile.PictureLink} alt='KeyNoteSpeaker' onClick={()=>handleSpeakerModalOpen(profile)}/>
                                                </center>
                                            </Grid>
                                            <Grid item xs={12} md={9} container justifyContent='flex-end' className='textAccentColor3'>
                                                <br/>
                                                {keynote.Description}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </>
                            )
                            )
                        }
                    </Container>
                </div>
                <SpeakerInfoModal show={speakerInfoOpen} onClose={handleSpeakerModalClose} speaker={selectedSpeaker}/>
            </>
            
            ))}
        </>
    )
};